import type { SVGProps } from 'react';
export const SvgChat = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={21}
		fill="none"
		viewBox="0 0 20 21"
		{...props}
	>
		<path
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit={10}
			d="M11 18.308c-.55.734-1.45.734-2 0l-1.25-1.666a.96.96 0 0 0-.667-.334h-.416c-3.334 0-5-.833-5-5V7.142q0-5 5-5h6.666q5 0 5 5v4.166"
		/>
		<path
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M15.167 18.333a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333M18.333 18.833 17.5 18M13.33 9.667h.008M9.996 9.667h.008M6.662 9.667h.008"
		/>
	</svg>
);
